module.exports = __webpack_public_path__ + "static/feedlot-e7da264a1aa268b4e0ffc4be4b41aa15.svg";